import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { LookupModel } from '../../models/common/lookup.model';
import { SaleTemplate } from '../../models/media/sale-template.model';
import {
  NewBreezeUpModal,
  SaleBreezeUpModel,
  SaleSettingModel,
} from '../../models/sales/sale-settings.model';
import { Sale } from '../../models/sales/sales.model';
import { LookupService } from '../../services/lookup.service';
import { SalesService } from '../../services/sales.service';
import { SettingsService } from '../../services/settings.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { format } from 'date-fns';
import { DateParserFormatter } from '../../utils/helper/date-parser-formatter';
import { SaleBreezeDateModalComponent } from '../sale-breeze-date-modal/sale-breeze-date-modal.component';
import { XrayCompleteType } from '../../shared-new/enums/xray-complete-type.enum';

@Component({
  selector: 'app-sale-setting',
  templateUrl: './sale-setting.component.html',
  styleUrls: ['./sale-setting.component.scss'],
})
export class SaleSettingComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  saleId: number;
  sale: Sale = null;
  isLoaderSale: boolean;
  selected = '0';
  form: FormGroup;
  @ViewChild('submissionElement') submissionElement: ElementRef;
  @ViewChild('viewingElement') viewingElement: ElementRef;
  @ViewChildren('saleDateTime') saleDateTime: QueryList<ElementRef>;
  @ViewChildren('breezeDateTime') breezeDateTime: QueryList<ElementRef>;
  @ViewChildren('xrayScopeTaken') xrayScopeTaken: QueryList<ElementRef>;
  @ViewChildren('xrayScopeTaken2') xrayScopeTaken2: QueryList<ElementRef>;
  @ViewChildren('xRayCommenceDate') xRayCommenceDate: QueryList<ElementRef>;
  @ViewChildren('xrayScopeVisible') xrayScopeVisible: QueryList<ElementRef>;
  @ViewChildren('xrayScopeVisible2') xrayScopeVisible2: QueryList<ElementRef>;
  @ViewChildren('startDate') startDate: QueryList<ElementRef>;
  public submitted = false;
  public saleTemplates: SaleTemplate[];
  public horseTypes: LookupModel[];
  public dateFormat: any;
  public isSubmissionDateChanged: boolean = false;
  public isViewingDateChanged: boolean = false;
  public model: SaleSettingModel = new SaleSettingModel();
  public displayedColumns$ = new BehaviorSubject([
    'saleDay',
    'saleDate',
    'breezeDate',
    'minLotNumber',
    'maxLotNumber',
    'bookNumber',
    'xRayCommenceDate',
  ]);
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private salesService: SalesService,
    private settingsService: SettingsService,
    private lookupService: LookupService,
    private formBuilder: FormBuilder,
    private toastService: ToastService,
    @Inject(DateParserFormatter)
    public dateParserFormatter: DateParserFormatter,
    private readonly modalService: NgbModal
  ) {
    super();
    this.form = SaleSettingModel.asFormGroup(this.model);
  }
  get saleSubmission(): FormArray {
    return this.form.get('saleSubmission') as FormArray;
  }
  get saleDocumentTypeAccess(): FormArray {
    return this.form.get('saleDocumentTypeAccess') as FormArray;
  }
  get saleSession(): FormArray {
    return this.form.get('saleSession') as FormArray;
  }

  get saleBreezeUp(): FormArray {
    return this.form.get('saleBreezeUp') as FormArray;
  }
  onDaysChange(e: any): void {
    const xrayCommenceDays = this.form.controls['xrayCommenceDays'].value;

    this.saleSession.controls.forEach((item, index) => {      
      const saleDate = new Date(
        (this.saleSession.at(index) as FormGroup).controls['startDate'].value
      );
      const newCommenceDate = this.subtractDaysFromDate(
        saleDate,
        xrayCommenceDays
      );
      (this.saleSession.at(index) as FormGroup).controls[
        'xrayScopeTaken'
      ].setValue(newCommenceDate);
      (this.saleSession.at(index) as FormGroup).markAsDirty();
    });

    //this.saleSession.controls.forEach((item) => {
    //  const saleDate = new Date(item.value.endDate);
    //  item.value.xRayCommenceDate = this.subtractDaysFromDate(saleDate, xrayCommenceDays);
    //  item.markAsDirty();
    //})
    this.form.updateValueAndValidity();
  }
  subtractDaysFromDate(date: Date, days: number): Date {
    var result = new Date(date);
    result.setDate(date.getDate() - days);
    return result;
  }
  ngOnInit(): void {
    this.saleId = Number(this.route.snapshot.paramMap.get('id'));
    this.loadSale(this.saleId);
    this.loadSaleTemplates();
    this.loadSaleSettings();
  }

  public loadSaleTemplates(): void {
    this.isLoaderSale = true;
    this.settingsService
      .getSaleTemplates()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.isLoaderSale = false;
        this.saleTemplates = response;
      });
  }
  toggleControl(submission: FormGroup): void {
    this.enableCheckboxFields(submission);

    if (submission.value['isActive']) {
      submission.controls['xrayCompleteType'].disable();
      submission.controls['isXRayReport'].disable();
      submission.controls['isScope'].disable();
      submission.controls['scopeReport'].disable();
      submission.controls['isAutoApproveSubmissions'].disable();
    } else {
      submission.controls['xrayCompleteType'].enable();
      submission.controls['isXRayReport'].enable();
      submission.controls['isScope'].enable();
      submission.controls['scopeReport'].enable();
      submission.controls['isAutoApproveSubmissions'].enable();
    }
  }
  onViewingDate(e: any) {
    this.model.viewingStartDate = this.dateParserFormatter.getDateInTimezone(
      e.start,
      this.model.timeZoneIana
    );
    this.model.viewingEndDate = this.dateParserFormatter.getDateInTimezone(
      e.end,
      this.model.timeZoneIana
    );
    this.isViewingDateChanged = true;
  }
  onSubmissionDate(e: any) {
    this.model.submissionStartDate = this.dateParserFormatter.getDateInTimezone(
      e.start,
      this.model.timeZoneIana
    );
    this.model.submissionEndDate = this.dateParserFormatter.getDateInTimezone(
      e.end,
      this.model.timeZoneIana
    );
    this.isSubmissionDateChanged = true;
  }

  onSelectDate($event: any, formGroup: FormGroup, field: string) {
    formGroup.patchValue({
      [field]: this.dateParserFormatter.getISODate($event.start),
    });
  }
  private setDateRangesInSaleTimeZone() {
    if (!this.isSubmissionDateChanged) {
      this.model.submissionStartDate =
        this.dateParserFormatter.getISODateInTimezone(
          this.model.submissionStartDate,
          this.model.timeZoneIana
        );
      this.model.submissionEndDate =
        this.dateParserFormatter.getISODateInTimezone(
          this.model.submissionEndDate,
          this.model.timeZoneIana
        );
    }
    if (!this.isViewingDateChanged) {
      this.model.viewingStartDate =
        this.dateParserFormatter.getISODateInTimezone(
          this.model.viewingStartDate,
          this.model.timeZoneIana
        );
      this.model.viewingEndDate = this.dateParserFormatter.getISODateInTimezone(
        this.model.viewingEndDate,
        this.model.timeZoneIana
      );
    }
  }
  /**
   * The stored value is a tri-state (Complete / Partial / NULL) but the sales
   * company only needs the on-off decision, so the checkbox maps onto it:
   * ticked writes Complete, cleared writes Partial. NULL is left meaning "not
   * enforced" for every sale that predates this setting being readable.
   */
  public isEnforceProtocol(submission: FormGroup): boolean {
    return (
      submission.controls['xrayCompleteType'].value ===
      XrayCompleteType.Complete
    );
  }

  public setEnforceProtocol(submission: FormGroup, enforce: boolean): void {
    submission.controls['xrayCompleteType'].setValue(
      enforce ? XrayCompleteType.Complete : XrayCompleteType.Partial
    );
    submission.controls['xrayCompleteType'].markAsDirty();
  }

  public enableCheckboxFields(submission: FormGroup): void {
    if (!submission.value['isActive']) {
      submission.controls['saleTemplateId'].disable();
    } else {
      submission.controls['saleTemplateId'].enable();
    }
  }

  onSubmit(): void {
    this.updateSettings(() =>
      setTimeout(() => {
        this.router.navigate([`/sales/`]);
      }, 500)
    );
  }

  updateSettings(callback: () => void): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    if (this.form.valid) {
      const form = this.form.value;
      this.setDateRangesInSaleTimeZone();
      form.viewingStartDate = this.model.viewingStartDate;
      form.viewingEndDate = this.model.viewingEndDate;
      form.submissionStartDate = this.model.submissionStartDate;
      form.submissionEndDate = this.model.submissionEndDate;
      this.model = form;
      this.model.saleSubmission = this.model.saleSubmission
        .filter((x) => x.isActive)
        .map((item) => {
          if (item.saleTemplateId === 0) {
            item.saleTemplateId = null;
          }
          return item;
        });

      this.model.saleBreezeUp = this.model.saleBreezeUp.map((breezeUp) => {
        return {
          ...breezeUp,
          id: breezeUp.id > 0 ? breezeUp.id : 0,
        };
      });
      this.isLoaderSale = true;
      this.salesService
        .updateSaleSettings(this.model)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response) => {
          this.isLoaderSale = false;
          this.model = response;
          this.form = SaleSettingModel.asFormGroup(this.model);
          this.toastService.success(
            'Sale settings have been updated successfully'
          );

          callback();
        });
    }
  }

  public loadSaleSettings(): void {
    this.isLoaderSale = true;
    this.salesService
      .getSaleSettings(this.saleId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.isLoaderSale = false;        
        this.model = response;
        this.form = SaleSettingModel.asFormGroup(this.model);
      });
  }
  public loadSale(saleId: number): void {
    this.isLoaderSale = true;
    this.salesService
      .getSale(saleId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((sale) => {        
        this.sale = sale;
        this.dateParserFormatter.setIsUSTimeZone(sale.lotOrHipText);
        this.dateFormat = this.dateParserFormatter.getMomentDateTimeFormat();
        this.isLoaderSale = false;
      });
  }

  openBreezeDateModal(breezeUp?: FormGroup): void {
    const modalRef = this.modalService.open(SaleBreezeDateModalComponent, {
      ariaLabelledBy: this.sale.saleId + 'Id',
      centered: true,
      size: 'full-width',
      keyboard: false,
      backdrop: 'static',
      fullscreen: true,
    });

    const books = this.generateModel(this.model);

    modalRef.componentInstance.data = {
      lotOrHipText: this.model.lotOrHipText,
      books,
      breezeUp: breezeUp || null,
    };
    modalRef.result.then(
      (result: FormGroup) => {
        if (result.value.id !== 0) {
          // We are editing a form group.
          this.updateBreezeUpEntry(result.value);
        } else {
          const newId = this.findLowestId(result.value);
          result.patchValue({ id: newId });
          this.saleBreezeUp.push(result);
        }
      },
      (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  generateModel(model: SaleSettingModel): any[] {
    const saleSession = model.saleSession;

    let uniqueBooks: number[] = [];
    saleSession.forEach((ss) => {
      if (!uniqueBooks.includes(ss.bookNumber)) {
        uniqueBooks.push(ss.bookNumber);
      }
    });

    const response = uniqueBooks.map((bookNumber) => {
      const model = saleSession
        .filter((ss) => ss.bookNumber === bookNumber)
        .map((ss) => {
          return {
            sessionNumber: ss.sessionNumber,
            saleDate: ss.startDate,
            firstHip: ss.minLotNumber,
            lastHip: ss.maxLotNumber,
          } as NewBreezeUpModal;
        })
        .sort((a, b) => {
          if (a.sessionNumber < b.sessionNumber) {
            return -1;
          } else if (a.sessionNumber === b.sessionNumber) {
            return 0;
          } else {
            return 1;
          }
        });

      return {
        bookNumber,
        sessions: model,
      };
    });
    return response;
  }
  removeZeroTime(dateObj: any): string{    
    let sessionEndDate = new Date( dateObj);
    if (sessionEndDate.getHours() == 0 && sessionEndDate.getMinutes() == 0 && sessionEndDate.getSeconds() == 0){
      return format(new Date(dateObj),this.dateParserFormatter.getDateFormatForSale(this.sale, false));
    } else {
      return format(new Date(dateObj),this.dateParserFormatter.getDateFormatForSaleWithTime(this.sale, false));
    }
}
  deleteBreezeUpEntry(breezeUpId: number): void {
    let fromArray = this.saleBreezeUp;
    let indexToRemove: number[] = [];
    fromArray.controls.forEach((control, index) => {
      if (control.value.id === breezeUpId) {
        indexToRemove.push(index);
      }
    });
    indexToRemove.reverse().forEach((index) => {
      fromArray.removeAt(index);
    });
  }

  updateBreezeUpEntry(breezeUp: SaleBreezeUpModel): void {
    let fromArray = this.saleBreezeUp;
    let indexToUpdate: number[] = [];
    fromArray.controls.forEach((control, index) => {
      if (control.value.id === breezeUp.id) {
        indexToUpdate.push(index);
      }
    });
    indexToUpdate.reverse().forEach((index) => {
      fromArray.at(index).patchValue(breezeUp);
    });
  }

  findLowestId(breezeUp: SaleBreezeUpModel): number {
    let fromArray = this.saleBreezeUp;
    let indexToUpdate: number[] = [];
    let lowestId = 0;
    fromArray.controls.forEach((control, index) => {
      if (control.value.id <= lowestId) {
        lowestId = control.value.id - 1;
        indexToUpdate.push(index);
      }
    });

    return lowestId;
  }

  editBreezeUpEntry(breezeUp: FormGroup): void {
    this.openBreezeDateModal(breezeUp);
  }

  openDatePicker(index: number, dateElement: any[]): void {
    const element = dateElement.filter((e, i) => i === index);

    if (element.length) {
      element[0].nativeElement.click();
    }
  }
}
